export const taxreportdata = [
  {
    id: 1,
    Img: 'assets/img/users/user-01.jpg',
    Customer: 'Mitchum Daniel',
    Date: '12 Jul 2023',
    InvoiceNumber: 'INV4237300',
    TotalAmount: '$30,000',
    PaymentMethod: 'assets/img/icons/pay.svg',
    Discount: '10',
    TaxAmount: '$457',
  },
  {
    id: 2,
    Img: 'assets/img/users/user-02.jpg',
    Customer: 'Susan Lopez',
    Date: '04 Aug 2023',
    InvoiceNumber: 'INV5385083',
    TotalAmount: '$27,000',
    PaymentMethod: 'assets/img/icons/stripe.svg',
    Discount: '08',
    TaxAmount: '$382',
  },
  {
    id: 3,
    Img: 'assets/img/users/user-03.jpg',
    Customer: 'Robert',
    Date: '25 Aug 2023',
    InvoiceNumber: 'INV7609368',
    TotalAmount: '$45,000',
    PaymentMethod: 'assets/img/icons/razorpay.svg',
    Discount: '15',
    TaxAmount: '$649',
  },
  {
    id: 4,
    Img: 'assets/img/users/user-04.jpg',
    Customer: 'Russell Belle',
    Date: '16 Sep 2023',
    InvoiceNumber: 'INV2750916',
    TotalAmount: '$18,000',
    PaymentMethod: 'assets/img/icons/pay.svg',
    Discount: '12',
    TaxAmount: '$104',
  },
  {
    id: 5,
    Img: 'assets/img/users/user-05.jpg',
    Customer: 'Edward Muniz',
    Date: '28 Oct 2023',
    InvoiceNumber: 'INV3478305',
    TotalAmount: '$22,000',
    PaymentMethod: 'assets/img/icons/pay.svg',
    Discount: '20',
    TaxAmount: '$290',
  },
];

export const purchasetaxreport = [
  {
    id: 1,
    Supplier: 'Lavi',
    Date: '12 Jul 2023',
    RefNo: '#4237300',
    TotalAmount: '$30,000',
    PaymentMethod: 'assets/img/icons/pay.svg',
    Discount: '10',
    TaxAmount: '$457',
  },
  {
    id: 2,
    Supplier: 'Anthony',
    Date: '18 Aug 2023',
    RefNo: '#5628954',
    TotalAmount: '$45,000',
    PaymentMethod: 'assets/img/icons/stripe.svg',
    Discount: '12',
    TaxAmount: '$265',
  },
  {
    id: 3,
    Supplier: 'Colleen',
    Date: '27 Aug 2023',
    RefNo: '#8745239',
    TotalAmount: '$26,000',
    PaymentMethod: 'assets/img/icons/razorpay.svg',
    Discount: '08',
    TaxAmount: '$980',
  },
  {
    id: 4,
    Supplier: 'Victor',
    Date: '05 Sep 2023',
    RefNo: '#9814586',
    TotalAmount: '$18,000',
    PaymentMethod: 'assets/img/icons/pay.svg',
    Discount: '15',
    TaxAmount: '$561',
  },
  {
    id: 5,
    Supplier: 'Tracy',
    Date: '23 Sep 2023',
    RefNo: '#7590325',
    TotalAmount: '$52,000',
    PaymentMethod: 'assets/img/icons/pay.svg',
    Discount: '20',
    TaxAmount: '$382',
  },
];
